module.exports = __webpack_public_path__ + "img/15exp.29bb2ac9.jpg";